import * as React from 'react';
import {
  PortableText,
  PortableTextProps,
  PortableTextReactComponents,
} from '@portabletext/react';
import {
  SanityAssetReference,
  SanitySecurityPriceGraph,
  SanityBulletListContainer,
  SanityBulletListElement,
  SanityDel,
  SanityEm,
  SanityEmbedded,
  SanityH1,
  SanityH2,
  SanityH3,
  SanityContentImage,
  SanityLink,
  SanityNormal,
  SanityNumberListContainer,
  SanityNumberListElement,
  SanityStrong,
  SanityTableWithData,
  SanityUnderline,
  SanityInternalLink,
  SanityFootnote,
  SanityFootnotes,
  SanityFileLink,
  SanityBondField,
} from './components';
import { FootnotesProvider } from './components/footnote/context';
import { SanityBondLink } from './components/bondLink';

const components: Partial<PortableTextReactComponents> = {
  types: {
    image: (props) => (
      <SanityContentImage
        value={props.value}
      />
    ),
    styledTable: (props) => (
      <SanityTableWithData
        value={props.value}
      />
    ),
    embedded: (props) => (
      <SanityEmbedded
        value={props.value}
      />
    ),
    securityPriceGraph: (props) => (
      <SanitySecurityPriceGraph value={props.value} />
    ),
    bondField: (props) => (
      <SanityBondField value={props.value} />
    ),
  },
  block: {
    normal: (props) => (
      <SanityNormal
        index={props.index}
      >
        {props.children}
      </SanityNormal>
    ),
    h1: (props) => (
      <SanityH1>
        {props.children}
      </SanityH1>
    ),
    h2: (props) => (
      <SanityH2>
        {props.children}
      </SanityH2>
    ),
    h3: (props) => (
      <SanityH3>
        {props.children}
      </SanityH3>
    ),
  },
  list: {
    bullet: (props) => (
      <SanityBulletListContainer>
        {props.children}
      </SanityBulletListContainer>
    ),
    number: (props) => (
      <SanityNumberListContainer>
        {props.children}
      </SanityNumberListContainer>
    ),
  },
  listItem: {
    bullet: (props) => (
      <SanityBulletListElement>
        {props.children}
      </SanityBulletListElement>
    ),
    number: (props) => (
      <SanityNumberListElement>
        {props.children}
      </SanityNumberListElement>
    ),
  },
  marks: {
    link: (props) => (
      <SanityLink
        value={props.value}
      >
        {props.children}
      </SanityLink>
    ),
    internalLink: (props) => (
      <SanityInternalLink
        value={props.value}
      >
        {props.children}
      </SanityInternalLink>
    ),
    bondLink: (props) => (
      <SanityBondLink
        value={props.value}
      >
        {props.children}
      </SanityBondLink>
    ),
    file: (props) => (
      <SanityFileLink
        value={props.value}
      >
        {props.children}
      </SanityFileLink>
    ),
    footnote: (props) => (

      <SanityFootnote
        value={props.value}
      >
        {props.children}
      </SanityFootnote>
    ),
    strong: (props) => (
      <SanityStrong>
        {props.children}
      </SanityStrong>
    ),
    em: (props) => (
      <SanityEm>
        {props.children}
      </SanityEm>
    ),
    underline: (props) => (
      <SanityUnderline>
        {props.children}
      </SanityUnderline>
    ),
    del: (props) => (
      <SanityDel>
        {props.children}
      </SanityDel>
    ),
    assetReference: (props) => (
      <SanityAssetReference
        value={props.value}
      >
        {props.children}
      </SanityAssetReference>
    ),
  },
};

export const OblisPortableText = (props: {
  content: PortableTextProps['value'],
}) => {
  const {
    content,
  } = props;
  return (
    <FootnotesProvider blocks={content}>
      <PortableText
        value={content}
        components={components}
      />
      <SanityFootnotes />
    </FootnotesProvider>
  );
};
